import React, { useContext } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import { storeDemoContact } from "../../redux/slices/demoContacts";
import NotyfContext from "../../contexts/NotyfContext";

const EmailPromptModal = ({ showEmailPrompt, setShowEmailPrompt }) => {
  const handleClose = () => setShowEmailPrompt(false);
  const notyf = useContext(NotyfContext);

  const initialValues = {
    email: "",
    consent: false,
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    consent: Yup.boolean().oneOf(
      [true],
      "You must agree to receive marketing communications"
    ),
  });

  const handleSubmit = async (values, actions) => {
    const payload = {
      email: values.email,
      consentMarketing: values.consent,
    };
    await storeDemoContact({ data: payload })
      .then(() => {
        notyf.open({
          type: "success",
          message:
            "Thank you! An email has been sent to the address you provided.",
          duration: 5000,
          ripple: true,
          dismissible: false,
          position: {
            x: "center",
            y: "top",
          },
        });
      })
      .catch((error) => {
        notyf.open({
          type: "danger",
          message: "Something went wrong",
          duration: 5000,
          ripple: true,
          dismissible: false,
          position: {
            x: "center",
            y: "top",
          },
        });
      })
      .finally(() => {
        actions.setSubmitting(false);
        setShowEmailPrompt(false);
      });
  };

  return (
    <Modal show={showEmailPrompt} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Stay Updated!</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <FormikForm>
            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>Email address</Form.Label>
                <Field
                  name="email"
                  type="email"
                  as={Form.Control}
                  placeholder="Enter your email"
                />
                <div className="text-danger mt-1">
                  <ErrorMessage name="email" />
                </div>
              </Form.Group>

              <Form.Group controlId="formConsentCheckbox">
                <Field
                  name="consent"
                  type="checkbox"
                  className="me-2"
                  as={Form.Check.Input}
                  style={{
                    "--dynamic-bg-color": "#0E1A2B",
                  }}
                />
                <Form.Label>
                  I agree to receive marketing communications and updates.
                </Form.Label>
                <div className="text-danger mt-1">
                  <ErrorMessage name="consent" />
                </div>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                style={{
                  "--dynamic-bg-color": "#0E1A2B",
                  "--dynamic-font-color": "#fff",
                  border: "none",
                }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                style={{
                  "--dynamic-bg-color": "#0E1A2B",
                  "--dynamic-font-color": "#fff",
                  border: "none",
                }}
                type="submit"
                disabled={isSubmitting}
              >
                Submit
              </Button>
            </Modal.Footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
};

export default EmailPromptModal;
